import React from 'react';
import { PropTypes } from 'prop-types';
import { label, labelContainer, mandatoryLabel, mandatoryLabelContainer, modalLabel } from '../assets/styles/label';

export class Label extends React.PureComponent {
  render() {
    const { text, secondaryText = '', isModal = false, isMandatory = false } = this.props;
    return (
      <div css={isMandatory ? mandatoryLabelContainer : labelContainer }>
        <p css={isModal ? modalLabel : label}>{text}</p>
        {secondaryText && <p css={isMandatory ? mandatoryLabel : label}>{secondaryText}</p>}
      </div>
    );
  }
}

Label.propTypes = {
  text: PropTypes.string,
};

export default Label;
